export const BASE_URL = process.env.REACT_APP_API_URL
export const BASE_URL_NO_API = process.env.REACT_APP_URL

// PROJECTS
export const getAllProjectsURL = (user_id) => `${BASE_URL}projects${user_id ? "?userid=" + user_id : ""}`
export const oneProjectURL = (project_id) => `${BASE_URL}projects/${project_id}`
export const getAllDeletedProjectsURL = () => `${BASE_URL}deleted/projects`
export const restoreDeletedProject = (project_id) => `${BASE_URL}deleted/projects/${project_id}/restore`

// USERS
export const allUsersURL = () => `${BASE_URL}users`
export const oneUserURL = (user_id) => `${BASE_URL}users/${user_id}`
export const currentUserURL = () => `${BASE_URL}users/current`
export const changePasswordURl = (user_id) => `${BASE_URL}users/${user_id}/changepassword`

// OKR
export const allOkrURL = (user_id) => `${BASE_URL}okrs${user_id ? "?userid=" + user_id : ""}`
export const oneOkrURL = (okr_id) => `${BASE_URL}okrs/${okr_id}`
export const allKeyResults = () => `${BASE_URL}keyresults`
export const oneKeyResultURL = (key_result_id) => `${BASE_URL}keyresults/${key_result_id}`


// TAGS
//export const allTagsURL = () => `${BASE_URL}tags`
export const oneTagsURL = (tag_id) => `${BASE_URL}tags/${tag_id}`
export const tagCategoriesURL = () => `${BASE_URL}tagcategories`
export const tagCategoryURL = (tag_category_id) => `${BASE_URL}tagcategories/${tag_category_id}`
export const tagByCategoryURL = (tag_category_id) => `${BASE_URL}tagcategories/${tag_category_id}/tags`

// ACTIONS
export const allActionURL = (user_id) => `${BASE_URL}actions${user_id ? "?userid=" + user_id : ""}`
export const oneActionURL = (action_id) => `${BASE_URL}actions/${action_id}`
export const okrActionURL = (krId) => `${BASE_URL}keyresults/${krId}/actions`
export const oneOkrActionURL = (action_id) => `${BASE_URL}actions/${action_id}`


// ACT WITH TEAM
export const actWithTeam = (project_id) => `${BASE_URL}notifications/actwithteam/${project_id}`

// NOTIFICATIONS
export const sendNotifications = (project_id) => `${BASE_URL}notifications/meetagain/${project_id}`
export const callAgain = () => `${BASE_URL}notifications/remindPilot`
export const sendPitchProjectURL = (project_id) => `${BASE_URL}notifications/pitchproject/${project_id}`
export const sendPitchStrategyURL = () => `${BASE_URL}notifications/strategypitch`

// MESSAGE TO BOSS
//export const messageToBossURL = () => `${BASE_URL}notifications/contact/ambassador`

// AXIS
export const getAllAxisURL = () => `${BASE_URL}axis`
export const oneAxisURL = (axis_id) => `${BASE_URL}axis/${axis_id}`

// STAKE
export const getStakesURL = () => `${BASE_URL}stakes`
export const getStakesURLWithoutSlash = () => `${BASE_URL}stakes`
export const getOneStakeURL = (stake_id) => `${BASE_URL}stakes/${stake_id}`

//SWOT
export const oneSwotItemURL = (swot_item_id) => `${BASE_URL}swots/${swot_item_id}`

//LOGIN
export const loginURL = () => `${BASE_URL}login`
export const azureLoginURL = () => `${BASE_URL_NO_API}azure_check`
export const refreshTokenURL = () => `${BASE_URL}token/refresh`

//HISTORY
export const projectHistoryURL = (project_id) => `${BASE_URL}history/projects/${project_id}`
export const userHistoryURL = (user_id) => `${BASE_URL}history/${user_id}`

// STRATEGY
export const strategyURL = () => `${BASE_URL}strategies`
export const oneStrategyURL = (strategy_id) => `${BASE_URL}strategies/${strategy_id}`
export const getAmbassadors = () => `${BASE_URL}strategy/ambassadors`
export const getBoardMembers = () => `${BASE_URL}strategy/codir`


//LOG
export const getLogsByEntityAndAttribute = (entity, attribute) => `${BASE_URL}history?entity=${entity}${attribute ? `&entityId=${attribute}` : ""}`


//ENJOYBOARD
export const enjoyBoardURL = () => "https://auth.enjoyboard.enjoyyourbusiness.fr/auth"


// KANBAN
export const contributionsURL = (id) => `${BASE_URL}contributions${id ? "/" + id : ""}`


// LINKS
export const linksURL = (id) => `${BASE_URL}links${id ? "/" + id : ""}`

// GANTT
export const ganttProjectsURL = (project_id) => `${BASE_URL}projects/gantt${project_id ? "/" + project_id : ""}`
